module.exports = __webpack_public_path__ + "static/media/sagar-logo.0910ad68.png";